import CommonIntroductionBase from "./common/CommonIntroductionBase";

const WebDesignIncludeBackend = () => {
  return (
    <CommonIntroductionBase
      slide="Webデザインとシステムの作成"
      collectionName="webdesignincludebackend"
      postTitle="Webデザイン情報"
      targetItems={[
        "order",
        "eventday",
        "title",
        "content",
        "linkUrl",
        "image",
      ]}
      linkMode="external"
    />
  );
};

export default WebDesignIncludeBackend;
